export const customerPreview = {
    selectCustomer: 'Kunde auswählen',
    refreshCustomers: 'Kunden aktualisieren',
    loadingCustomers: 'Kunden werden geladen...',
    noCustomerSelected: 'Wählen Sie einen Kunden aus, um Nutzung und Abrechnung vorzuschauen.',
    previewingCustomer: 'Kunde in Vorschau',
    safetyNotes: 'Sicherheitsnotizen',
    safetyNotesDescription:
      'Halten Sie Portal- und Zahlungslinks auf Einmalverwendung beschränkt. Vermeiden Sie es, Stripe-IDs oder Metadaten direkt weiterzugeben.',
    changePlanTitle: 'Plan wechseln',
    changePlanDescription:
      'Geben Sie eine Plan-ID an, um dieses Abonnement zu wechseln. Die Proration wird erfasst, Stripe-Proration wird derzeit noch nicht unterstützt.',
    planIdLabel: 'Plan',
    planTypeFilterLabel: 'Plantyp',
    planTypeFilterAll: 'Alle Pläne',
    planTypeFilterIndividual: 'Einzelnutzer',
    planTypeFilterTeam: 'Team',
    planIdPlaceholder: 'plan_...',
    planSelectPlaceholder: 'Plan auswählen',
    planSelectLoading: 'Pläne werden geladen...',
    planSelectEmpty: 'Keine Pläne verfügbar',
    currentBadge: 'Aktuell',
    variantBadge: 'Variante',
    planVariantSuffix: '(Variante)',
    planCycleLabel: 'Abrechnungszeitraum',
    planCyclePlaceholder: 'Abrechnungszeitraum auswählen',
    planCycleEmpty: 'Keine Abrechnungszeiträume verfügbar',
    planIdRequired: 'Plan ist erforderlich',
    planAlreadyCurrent: 'Der ausgewählte Plan ist bereits aktiv.',
    planCycleRequired: 'Abrechnungszeitraum ist erforderlich',
    planCycleUnavailable: 'Für den ausgewählten Plan sind keine Abrechnungszeiträume verfügbar.',
    workspaceNameLabel: 'Workspace-Name',
    workspaceNamePlaceholder: 'Workspace-Namen eingeben',
    workspaceNameHelper: 'Erforderlich beim Wechsel von Einzel- zu Team-Plan.',
    workspaceNameRequired: 'Workspace-Name ist erforderlich.',
    workspaceNameMinLength: 'Der Workspace-Name muss mindestens 2 Zeichen haben.',
    workspaceNameMaxLength: 'Der Workspace-Name darf höchstens 255 Zeichen haben.',
    subscriptionNotFoundTitle: 'Abonnement nicht gefunden',
    subscriptionNotFound:
      'Das Abonnement wurde nicht gefunden. Aktualisieren Sie den Kundenkontext und versuchen Sie es erneut.',
    subscriptionNotFoundToast: 'Abonnement nicht gefunden. Bitte aktualisieren und erneut versuchen.',
    prorateChange: 'Planwechsel proraten',
    prorateHint: 'Verwendet Proration-Metadaten aus dem Backend.',
    changePlanCta: 'Plan wechseln',
    planChangeSuccess: 'Plan gewechselt',
    planChangeSuccessWithCycle: 'Plan wurde auf {{plan}} ({{cycle}}) geändert',
    planChangeError: 'Planwechsel nicht möglich',
    noSubscriptionSelectionUnavailable:
      'Es gibt noch kein aktives Abonnement. Aktualisieren Sie den Kundenkontext, bevor Sie einen Plan auswählen.',
    billingPlan: 'Abrechnungsplan',
    billingPlanDescription: 'Aktuelles Abonnement, Preis, Berechtigungen und Aktionen.',
    planLabel: 'Plan',
    noPlan: 'Kein Plan ausgewählt',
    noPrice: 'Kein Preis',
    introPriceLabel: 'Einführungspreis',
    basePriceLabel: 'Grundpreis',
    basePriceStarts: 'Grundpreis beginnt',
    basePriceAfterIntro: 'Nach der Einführungsphase',
    quantity: 'Menge',
    period: 'Zeitraum',
    trialRemaining_one: 'Testphase endet in {{count}} Tag',
    trialRemaining_other: 'Testphase endet in {{count}} Tagen',
    entitlements: 'Berechtigungen',
    entitlementSeats: 'Sitze',
    entitlementProjects: 'Projekte',
    entitlementStorage: 'Speicher',
    entitlementSupport: 'Support',
    noEntitlements: 'Keine Berechtigungen hinterlegt.',
    trialEnds: 'Testphase endet',
    endsAt: 'Endet am',
    sendPayLink: 'Zahlungslink senden',
    payLinkCreated: 'Zahlungslink erstellt',
    payLinkError: 'Zahlungslink konnte nicht erstellt werden',
    noSubscription: 'Kein Abonnement für diesen Kunden gefunden.',
    selectSubscriptionCta: 'Abonnement auswählen',
    usageOverview: 'Nutzungsübersicht',
    usagePeriod: 'Aktueller Nutzungszeitraum und Limits. Zeitraum: {{start}} → {{end}} ({{tz}})',
    noUsage: 'Keine Nutzung in diesem Zeitraum erfasst.',
    used: 'verwendet',
    limit: 'Limit',
    unlimited: 'Unbegrenzt',
    unlimitedUsage: 'Unbegrenzte Nutzung',
    usageRecords: 'Nutzungsprotokolle',
    usageRecordsDescription: 'Aktuelle Nutzungsereignisse für diesen Zeitraum.',
    allMetrics: 'Alle Metriken',
    metricFilter: 'Metrik filtern',
    recordedAt: 'Erfasst am',
    metric: 'Metrik',
    endpoint: 'Endpunkt',
    credits: 'Credits',
    cost: 'Kosten',
    pageXofY: 'Seite {{page}}{{of}}',
    of: 'von',
    prev: 'Zurück',
    next: 'Weiter',
    noUsageFiltered: 'Keine Nutzungsdaten für die ausgewählten Filter.',
    noUsageRecords: 'Keine Nutzungsdaten verfügbar.',
    recentInvoices: 'Letzte Rechnungen',
    invoicesDescription: 'Aktuellste Rechnungen aus der Abrechnung.',
    invoice: 'Rechnung',
    issued: 'Ausgestellt',
    noInvoices: 'Keine Rechnungen verfügbar.',
    paymentMethod: 'Zahlungsmethode',
    paymentMethodDescription: 'Standard-Zahlungsmethode hinterlegt.',
    card: 'Karte',
    default: 'Standard',
    expires: 'Gültig bis',
    funding: 'Kartentyp',
    noPaymentMethod: 'Keine Zahlungsmethode hinterlegt.',
    paymentUnavailable: 'Zahlungsmethode nicht verfügbar.',
    upcomingPhases: 'Kommende Phasen',
    nextInvoice: 'Nächste Rechnung',
    nextInvoiceValue: '{{amount}} • {{date}}',
    priceUpdate: 'Preisaktualisierung',
    priceUpdateValue: 'Von {{from}} auf {{to}}{{interval}}',
    metrics: {
      apiCalls: 'API-Aufrufe',
      storage: 'Speicher',
      seats: 'Sitze',
      creditDeduction: 'Credits abgezogen',
    },
    usageStatus: {
      within: 'Im Rahmen',
      nearing: 'Kurz vor Limit',
      exceeded: 'Überschritten',
      unlimited: 'Unbegrenzt',
    },
  } as const;

const customers = {
    title: 'Kundenverwaltung',
    subtitle: 'Verwalten Sie individuelle Kunden und ihre Team-Beziehungen',
    create: {
      title: 'Kunde anlegen',
      description: 'Lade eine Einzelperson oder einen Team-Inhaber in dein Provider-Portal ein.',
      success: 'Kunde wurde erfolgreich erstellt',
      error: 'Kunde konnte nicht erstellt werden',
      submit: 'Kunde erstellen',
      fields: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail-Adresse',
        emailDescription: 'An diese Adresse senden wir die Aktivierungsanweisungen.',
        accountType: 'Kontotyp',
        accountTypeDescription: 'Wähle, ob du eine Einzelperson oder einen Workspace-Inhaber hinzufügst.',
        individual: 'Einzelperson',
        teamOwner: 'Team-Inhaber',
        teamName: 'Workspace-Name',
        teamNamePlaceholder: 'z. B. Acme Plattform Team',
        company: 'Unternehmen',
        phone: 'Telefonnummer',
        initialProduct: 'Startprodukt hinzufügen',
        selectProduct: 'Produkt auswählen',
        noProduct: 'Kein Produkt zuweisen',
        initialProductDescription: 'Optional: Weise automatisch Zugang zu einem deiner Produkte zu.',
      },
    },
    teams: {
      title: 'Team-Arbeitsbereich',
      subtitleWithProvider: 'Verwalte Einladungen, Rollen und Sitzplatznutzung für den Automatisierungs-Arbeitsbereich von {{providerName}}.',
      subtitleWithoutProvider: 'Verwalte Einladungen, Rollen und Sitzplatznutzung für deinen Automatisierungs-Arbeitsbereich.',
      create: {
        title: 'Team-Arbeitsbereich erstellen',
        description: 'Erstelle einen gemeinsamen Workspace und lade dein Team ein.',
        fields: {
          name: 'Teamname',
          description: 'Beschreibung',
          slug: 'Workspace-Slug',
          maxSeats: 'Sitzplatzlimit',
        },
        placeholders: {
          name: 'z. B. Acme Platform Team',
          description: 'Wofür ist dieses Team zuständig?',
          slug: 'acme-platform',
          maxSeats: '10',
        },
        helper: 'Dein persönliches Abo wird nach der Erstellung in einen Team-Plan umgewandelt.',
        submit: 'Team erstellen',
        submitting: 'Team wird erstellt…',
        success: 'Team erstellt. Workspace wird synchronisiert.',
        errors: {
          generic: 'Team konnte nicht erstellt werden.',
        },
        validation: {
          nameRequired: 'Teamname ist erforderlich.',
          descriptionMax: 'Die Beschreibung ist zu lang.',
          slugMax: 'Der Slug ist zu lang.',
          seatsInvalid: 'Das Sitzplatzlimit muss eine Zahl sein.',
          seatsRange: 'Das Sitzplatzlimit muss zwischen 1 und 1000 liegen.',
        },
        ineligibleTitle: 'Teamerstellung nicht verfügbar',
        ineligibleDescription: 'Nur Einzelkunden können einen neuen Team-Workspace erstellen.',
        ineligibleHelp: 'Wenn du ein neues Team brauchst, wende dich an den Workspace-Owner.',
        subscriptionCanceled: 'Dein persönliches Abo endet am Ende des aktuellen Abrechnungszeitraums.',
        subscriptionCanceledWithDate: 'Dein persönliches Abo endet am {{date}}.',
      },
      activeTeamLabel: 'Aktives Team',
      selectPlaceholder: 'Wähle ein Team',
      seatUsageLabel: 'Sitzplatznutzung',
      seatUsageHelper: '{{percentage}} % der verfügbaren Sitzplätze belegt',
      stats: {
        activeMembers: {
          label: 'Aktive Mitglieder',
          helper: 'Enthält Besitzer, Admins und Mitglieder',
        },
        pendingInvitations: {
          label: 'Ausstehende Einladungen',
          helperPending: 'Fasse bei ausstehenden Einladungen nach',
          helperEmpty: 'Keine ausstehenden Einladungen',
        },
        monthlySpend: {
          label: 'Monatliche Ausgaben',
          helper: 'Teamanteil an Produktabonnements',
        },
      },
      roles: {
        owner: 'Besitzer',
        admin: 'Admin',
        member: 'Mitglied',
      },
      members: {
        title: 'Mitglieder',
        description: 'Verwalte Rollen und entferne den Zugriff deiner Workspace-Mitglieder.',
        tableHeaders: {
          name: 'Name',
          role: 'Rolle',
          status: 'Status',
          credits: 'Credits',
          lastActive: 'Zuletzt aktiv',
          actions: 'Aktionen',
        },
        credits: {
          usage: '{{used}} / {{limit}} Credits',
          usageUnlimited: '{{used}} Credits verwendet',
          remaining: '{{remaining}} Credits übrig',
          limitReached: 'Limit erreicht',
        },
        actionsMenuAria: 'Mitgliedsaktionen öffnen',
        actionsLabel: 'Aktionen',
        limitUsage: 'Verbrauch begrenzen',
        remove: 'Entfernen',
        removeTitle: '{{memberName}} aus {{teamName}} entfernen?',
        removeDescription:
          'Dieses Mitglied verliert sofort den Zugriff auf alle Teamressourcen und teambezogene API-Keys werden umgehend widerrufen. Du kannst es später erneut einladen.',
        removeConfirm: 'Mitglied entfernen',
      },
      invite: {
        title: 'Teammitglieder einladen',
        description:
          'Sende eine Workspace-Einladung mit den richtigen Berechtigungen. Neue Mitglieder zählen gegen dein Sitzplatzlimit.',
        fields: {
          email: 'E-Mail-Adresse',
          role: 'Rolle',
          message: 'Nachricht (optional)',
        },
        placeholder: {
          email: 'alex@example.com',
          message: 'Füge Kontext für die eingeladene Person hinzu',
        },
        seatLimitReached:
          'Dein Team hat das Sitzplatzlimit erreicht. Entferne ein Mitglied oder buche zusätzliche Plätze, um weitere Personen einzuladen.',
        submit: 'Einladung senden',
        submitting: 'Sende Einladung…',
      },
      pending: {
        title: 'Ausstehende Einladungen',
        description: 'Behalte offene Einladungen im Blick und erinnere Teammitglieder bei Bedarf.',
        empty: 'Derzeit keine ausstehenden Einladungen.',
        invitedBy: 'Eingeladen von {{invitedBy}} am {{invitedAt}}{{expires}}',
        expires: ' • Läuft am {{date}} ab',
        managementComingSoon: 'Verwaltung von Einladungen folgt in Kürze',
        actions: {
          resend: 'Erneut senden',
          revoke: 'Widerrufen',
        },
        status: {
          pending: 'Ausstehend',
          revoked: 'Widerrufen',
          accepted: 'Angenommen',
          declined: 'Abgelehnt',
          expired: 'Abgelaufen',
        },
      },
      snapshot: {
        title: 'Workspace-Übersicht',
        description: 'Kurzer Überblick über deinen Team-Footprint.',
        totalCustomers: 'Gesamtzahl Kunden',
        teamsCreated: 'Erstellte Teams',
        teamOwners: 'Team-Besitzer',
        teamMembers: 'Team-Mitglieder',
        individualsHelper: '{{formattedCount}} ohne Team',
      },
      dialog: {
        title: 'Nutzungslimit',
        titleWithMember: 'Nutzungslimit für {{name}}',
        description:
          'Lege fest, wie viele Credits dieses Teammitglied verbrauchen darf, bevor wir Anfragen zur Freigabe weiterleiten.',
        enforceLabel: 'Credit-Limit erzwingen',
        enforceDescription: 'Schalte aus, um unbegrenzten Verbrauch für dieses Teammitglied zu erlauben.',
        creditLabel: 'Monatliches Credit-Kontingent',
        creditDescription:
          'Blockiert weitere Nutzung, sobald das Mitglied innerhalb des Kalendermonats so viele Credits verbraucht hat.',
        emailAlertsLabel: 'E-Mail-Benachrichtigungen',
        emailAlertsDescription:
          'Benachrichtigt das Mitglied und Workspace-Besitzer, sobald das Limit erreicht ist. Außerdem erfolgt eine Meldung bei 80 % Verbrauch.',
        cancel: 'Abbrechen',
        save: 'Limit speichern',
        saving: 'Speichere…',
      },
      validation: {
        invalidEmail: 'Gib eine gültige E-Mail-Adresse ein',
        messageTooLong: 'Der Einladungstext darf höchstens 280 Zeichen enthalten',
        creditRequired: 'Gib einen Credit-Betrag ein',
        creditNonNegative: 'Verwende einen nicht-negativen Credit-Betrag',
      },
      fallback: {
        loadErrorTitle: 'Teams',
        loadErrorDescription: 'Wir konnten deine Teamdaten gerade nicht laden.',
        loadErrorHelp: 'Bitte lade die Seite neu oder kontaktiere support@florentin.app, falls das Problem bestehen bleibt.',
        emptyTitle: 'Erstelle dein erstes Team',
        emptyDescription: 'Lade Teammitglieder ein, sobald dein Workspace eingerichtet ist.',
        emptyHelp:
          'Bitte deinen Provider-Admin, ein Team für dieses Konto bereitzustellen. Sobald es existiert, kannst du Einladungen und Rollen hier verwalten.',
      },
    },
    totalRequests: 'Gesamt-Requests',
    responseTime: 'Response Time',
    successRate: 'Erfolgsrate',
    issues: '{{count}} Probleme',
    fixIssues: 'Probleme Beheben',
    
    // Customer List
    addCustomer: 'Kunde hinzufügen',
    totalCustomers: 'Gesamt-Kunden',
    teamOwners: 'Team-Owner',
    teamMembers: 'Team-Mitglieder',
    individualOnly: 'Nur Individual',
    totalTeams: 'Gesamt-Teams',
    avgProductsPerCustomer: 'Ø Produkte/Kunde',
    searchPlaceholder: 'Suche nach Name, E-Mail, Firma oder Team...',
    allRoles: 'Alle Rollen',
    owners: 'Team-Owner',
    members: 'Team-Mitglieder',
    individual: 'Nur Individual',
    mixedRoles: 'Gemischte Rollen',
    allStatus: 'Alle Status',
    active: 'Aktiv',
    trial: 'Testversion',
    inactive: 'Inaktiv',
    suspended: 'Gesperrt',
    moreFilters: 'Weitere Filter',
    
    // Table Headers
    customer: 'Kunde',
    rolesAndTeams: 'Rollen & Teams',
    subscriptions: 'Abonnements',
    status: 'Status',
    usage: 'Nutzung',
    monthlyValue: 'Monatlicher Wert',
    created: 'Erstellt',
    operations: 'Operations',
    
    // Role Labels
    owner: 'Owner',
    member: 'Member',
    
    // Actions
    viewDetails: 'Details anzeigen',
    editCustomer: 'Kunde bearbeiten',
    manageSubscriptions: 'Abonnements verwalten',
    suspendAccount: 'Konto sperren',
    
    // Expanded Details
    subscriptionDetails: 'Abonnement-Details',
    individualSubscriptions: 'Individual-Abonnements',
    teamOwnerships: 'Team-Eigentümer',
    teamMemberships: 'Team-Mitgliedschaften',
    team: 'Team',
    plan: 'Plan',
    
    // Customer Detail
    rolesSummary: '{{ownerCount}} Team-Owner | {{memberCount}} Team-Mitglied | Individual-Abonnent',
    lastActive: 'Zuletzt aktiv',
    accountMetrics: 'Account-Metriken',
    totalMonthlySpend: 'Gesamte monatliche Ausgaben',
    accountHealthScore: 'Account Health Score',
    productsUsed: 'Verwendete Produkte',
    
    // Tabs
    overview: 'Übersicht',
    profile: 'Profil',
    apiKeys: 'API-Schlüssel',
    billing: 'Abrechnung',
    teamMembersTab: 'Team-Mitglieder',
    
    // Sections
    personalInformation: 'Persönliche Informationen',
    contactDetails: 'Kontaktdaten',
    communicationPreferences: 'Kommunikationspräferenzen',
    tagsAndAttributes: 'Tags & Benutzerdefinierte Attribute',
    accountSettings: 'Account-Einstellungen',
    ownedSubscriptions: 'Eigene Abonnements',
    
    // Team Management
    seatsUsed: '{{used}} von {{total}} Plätzen verwendet',
    manageTeam: 'Team verwalten',
    addMembers: 'Mitglieder hinzufügen',
    viewTeam: 'Team anzeigen',
    leaveTeam: 'Team verlassen',
    teamOwner: 'Team-Owner',
    yourUsage: 'Ihre Nutzung',
    nextBilling: 'Nächste Abrechnung',
    
    // API Keys
    personalApiKeys: 'Persönliche API-Schlüssel',
    teamApiKeys: 'Team API-Schlüssel',
    createPersonalKey: 'Persönlichen Schlüssel erstellen',
    viewTeamKeys: 'Team-Schlüssel anzeigen',
    manageTeamKeys: 'Team-Schlüssel verwalten',
    
    // Create Customer Dialog (erweitert)
    createDialog: {
      title: 'Neuen Kunden erstellen',
      description: 'Fügen Sie einen neuen Kunden zu Ihrer Plattform hinzu',
      submit: 'Kunde erstellen',
      fields: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail-Adresse',
        emailDescription: 'Wird für Login und Benachrichtigungen verwendet',
        company: 'Unternehmen (Optional)',
        phone: 'Telefon (Optional)',
        timezone: 'Zeitzone',
        timezoneSelect: 'Wählen Sie eine Zeitzone',
        accountType: 'Account-Typ',
        accountTypeDescription: 'Wählen Sie, ob dies ein individueller Account oder Team-Besitzer ist',
        individual: 'Individueller Account',
        teamOwner: 'Team-Besitzer',
        teamName: 'Team-Name',
        teamNamePlaceholder: 'Team-Namen eingeben',
        initialProduct: 'Erstes Produkt (Optional)',
        selectProduct: 'Produkt auswählen',
        noProduct: 'Kein erstes Produkt',
        initialProductDescription: 'Optional den Kunden sofort für ein Produkt abonnieren'
      }
    },
    register: {
      title: 'Kundenkonto erstellen',
      subtitle: 'Richte einen neuen Kunden ein und erstelle optional das Team',
      individualCopy: 'Erstellt ein persönliches Konto mit individuellen Abonnements.',
      teamOwnerCopy: 'Weist die Inhaberschaft eines Team-Workspaces mit Sitzverwaltung zu.',
      teamSectionTitle: 'Team-Details',
      teamSectionDescription: 'Gib den Teamnamen für den Basisplan an.',
      totalSeatsLabel: 'Enthaltene Plätze',
      totalSeatsDescription: 'Wie viele Plätze enthalten sind, bevor zusätzliche Plätze berechnet werden.',
      sendInviteLabel: 'Willkommens-E-Mail senden',
      sendInviteDescription: 'Sende dem Kunden die nächsten Schritte und einen Link zur Aktivierung.',
      termsLabelPrefix: 'Ich stimme den',
      termsLabelSuffix: ' zu',
      termsRequired: 'Du musst den Nutzungsbedingungen zustimmen, um fortzufahren.',
      validation: {
        firstNameRequired: 'Bitte gib einen Vornamen an.',
        lastNameRequired: 'Bitte gib einen Nachnamen an.',
        emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse an.',
        teamNameRequired: 'Der Teamname ist für Team-Owner erforderlich.',
        workspaceNameRequired: 'Bitte gib einen Workspace-Namen für das Team an.',
      },
      submitting: 'Konto wird erstellt...',
      submitCta: 'Kundenkonto erstellen',
      haveAccount: 'Verwaltest du bereits Kunden?',
      successTitle: 'Kunde ist startklar',
      successSubtitle: 'Wir haben das Konto erstellt, das Team synchronisiert und eine Verifizierungs-E-Mail gesendet. Bitte den Kunden, die E-Mail-Adresse vor dem Login zu bestätigen.',
      successToast: 'Kunde wurde erfolgreich registriert.',
      errorToast: 'Kunde konnte nicht registriert werden. Bitte versuche es erneut.',
      teamErrorToast: 'Team-Erstellung fehlgeschlagen. Du kannst das Team später konfigurieren.',
      teamSummary: '{{members}} von {{total}} Plätzen belegt.',
      createAnotherCta: 'Weiteren Kunden registrieren',
      summary: {
        customerName: 'Kundenname',
        customerEmail: 'E-Mail-Adresse',
        company: 'Unternehmen',
        teamName: 'Team',
        seats: '{{used}} von {{total}} Plätzen belegt',
      },
      loginRequiredTitle: 'Anmelden, um Kunden zu verwalten',
      loginRequiredDescription: 'Melde dich mit deinem Provider-Konto an, bevor du neue Kunden erstellst.',
    },
    
    // Edit Customer Dialog
    edit: {
      title: 'Kunde bearbeiten',
      description: 'Kundeninformationen aktualisieren',
      submit: 'Änderungen speichern',
      ownerWarning: 'Dieser Kunde ist ein Team-Besitzer. Änderungen betreffen alle Team-Mitglieder.',
      memberWarning: 'Dieser Kunde ist ein Team-Mitglied. Einige Einstellungen werden vom Team-Besitzer verwaltet.',
      fields: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail-Adresse',
        emailNote: 'E-Mail kann nach Account-Erstellung nicht geändert werden',
        company: 'Unternehmen',
        phone: 'Telefon',
        timezone: 'Zeitzone',
        status: 'Account-Status',
        statusDescription: 'Kundenzugriff auf die Plattform kontrollieren',
        twoFactor: 'Zwei-Faktor-Authentifizierung',
        twoFactorDescription: 'Zusätzliche Verifizierung für Login erforderlich'
      }
    },
    detail: {
      resetPassword: 'Passwort zurücksetzen',
      suspendAccount: 'Account sperren',
      growthIndicator: '+12 % im Vergleich zum Vormonat',
      creditBalance: 'Creditsaldo',
      creditsLabel: 'Credits',
      creditsUsed: '{{count}} Credits in diesem Monat genutzt',
      fullName: 'Vollständiger Name',
      email: 'E-Mail',
      phone: 'Telefon',
      company: 'Unternehmen',
      customerId: 'Kunden-ID',
      language: 'Sprache',
      timezone: 'Zeitzone',
      ownedSubscriptionsDescription: 'Produkte und Teams, die dieser Kunde besitzt oder individuell abonniert',
      individualSubscriptions: 'Individuelle Abonnements',
      teamSubscriptionsOwner: 'Team-Abonnements (Inhaber)',
      allSubscriptions: 'Alle Abonnements',
      apiKeys: 'API-Schlüssel',
      teamApiKeys: 'Team-API-Schlüssel',
      billingHistory: 'Abrechnungshistorie',
      allSubscriptionsDescription: 'Verwalte alle Abonnements, die diesem Kunden zugeordnet sind',
      monthlyTeamSpendDescription: 'Gesamtkosten für alle Team-Abonnements',
      monthlyTeamSpendTitle: 'Monatliche Teamkosten',
      membersCount: '{{count}} Mitglieder',
      teamMemberContext: 'Als Teammitglied hast du Zugriff auf Team-Ressourcen, die Abrechnung erfolgt jedoch durch den Team-Inhaber.',
      personalKeysDescription: 'API-Schlüssel, die diesem Kunden persönlich gehören',
      teamKeysDescription: 'API-Schlüssel von Teams, denen dieser Kunde angehört',
      billingHistoryDescription: 'Letzte Rechnungen und Zahlungen',
      columns: {
        name: 'Name',
        key: 'Schlüssel',
        team: 'Team',
        created: 'Erstellt',
        date: 'Datum',
        product: 'Produkt',
        type: 'Typ',
        plan: 'Tarif',
        status: 'Status',
        creditUsage: 'Credit-Nutzung',
        monthlyCost: 'Monatliche Kosten',
        nextBilling: 'Nächste Abrechnung',
        seats: 'Sitze',
        monthlySpend: 'Monatlicher Umsatz',
        lastActive: 'Zuletzt aktiv',
        actions: 'Aktionen',
        issued: 'Ausgestellt',
        lastUsed: 'Zuletzt verwendet',
        permissions: 'Berechtigungen',
        amount: 'Betrag',
        description: 'Beschreibung'
      },
      actions: {
        upgradePlan: 'Tarif upgraden',
        viewUsage: 'Nutzung ansehen',
        cancelSubscription: 'Kündigen',
        download: 'Herunterladen',
        refresh: 'Aktualisieren',
        rotate: 'Rotieren',
        regenerate: 'Neu generieren',
        revoke: 'Widerrufen',
        viewTeamKeys: 'Schlüssel anzeigen'
      },
      badges: {
        individual: 'Individuell',
        team: 'Team',
        owner: 'Inhaber',
        member: 'Mitglied'
      },
      show: 'Anzeigen',
      hide: 'Ausblenden',
      copyKey: 'API-Schlüssel kopieren',
      masked: 'Ausgeblendet',
      apiKeyLabel: 'API-Schlüssel',
      noTeamKeys: 'Keine Team-API-Schlüssel verfügbar.',
      refreshKeys: 'Schlüssel aktualisieren',
      rotateKey: 'Schlüssel rotieren',
      sampleProducts: {
        emailApi: 'E-Mail-API',
        smsApi: 'SMS-API',
        analyticsApi: 'Analytics-API',
        workflowApi: 'Workflow-API'
      },
      planLabel: '{{plan}}-Tarif',
      monthlyValue: '{{amount}} $/Monat',
      operationsCount: '{{formattedCount}} Vorgänge',
      operationsCount_one: '{{formattedCount}} Vorgang',
      operationsCount_other: '{{formattedCount}} Vorgänge',
      teamPlanSummary: '{{plan}}-Tarif • {{seats}} Plätze',
      creditUsageSummary: '{{used}} / {{limit}} Credits',
      teamAccess: 'Team-Zugriff',
      teamManaged: 'Vom Team verwaltet',
      totalSpentTitle: 'Gesamtausgaben',
      totalSpentSubtitle: 'Lebenszeitwert',
      creditBalanceCardTitle: 'Creditsaldo',
      creditBalanceSubtitle: 'Verfügbare Credits',
      nextPaymentTitle: 'Nächste Zahlung',
      nextPaymentSubtitle: 'Fällig am {{date}}',
      nextBillingLabel: 'Nächste Abrechnung: {{date}}',
      profileTitle: 'Profilübersicht',
      profileSubtitle: 'Kernattribute, die aus deiner Automationsplattform synchronisiert werden.',
      loadingName: 'Kunde',
      none: 'Nicht angegeben',
      noTeams: 'Einzelkonto',
      noData: 'Kundendetails nicht verfügbar.',
      nextStepsTitle: 'Automatisierungstipps',
      nextStepsDescription:
        'Nutze Service-Tokens, um Syncs zu planen und ein nahtloses Kundenportal-Erlebnis zu liefern.',
      tipTokens: 'Portal-Tokens regelmäßig rotieren',
      tipTokensDescription:
        'Entferne ungenutzte Service-Tokens im Provider-API-Bereich, um veraltete Automationszugänge zu vermeiden.',
      tipSso: 'SSO-Aktivität prüfen',
      tipSsoDescription:
        'Verfolge ausgegebene Links und deaktiviere Integrationen, die unerwartete Portal-Sessions erzeugen.',
      tipTeams: 'Team-Zugriff erkannt',
      tipTeamsDescription:
        'Team-Owner erhalten denselben Portalzugriff wie Einzel-Logins. Prüfe, ob nachgelagerte Tools Sitzplatzlimits durchsetzen.',
      openPortal: 'Kundenportal öffnen',
      ssoConfirmTitle: 'Sicheren Portal-Link erstellen?',
      ssoConfirmDescription:
        'Für {{name}} wird ein einmaliger Magic Link erstellt. Die Person wird sofort im Portal angemeldet.',
      ssoConfirmAction: 'Link erstellen',
      ssoIssuing: 'Link wird erstellt…',
      ssoLinkIssued: 'Kundenportal wurde in einem neuen Tab geöffnet.',
      ssoLinkError: 'Portal-Link konnte nicht erstellt werden. Bitte später erneut versuchen.',
      loadError: 'Kunde konnte nicht geladen werden.',
      retry: 'Erneut versuchen'
    },
    checkoutLinks: {
      title: 'Checkout-Links',
      description: 'Erstelle tokenisierte Checkout-Links für {{name}} und prüfe die letzten Links.',
      generateTitle: 'Neuen Checkout-Link erzeugen',
      generateDescription: 'Wähle Produkt, Plan/Paket und Preis aus dem Billing-Setup.',
      generateAction: 'Link erzeugen',
      generatePending: 'Wird erzeugt...',
      generateSuccess: 'Checkout-Link erstellt.',
      generateError: 'Checkout-Link konnte nicht erstellt werden.',
      latestTitle: 'Letzter Checkout-Link',
      expiresAtLabel: 'Läuft ab {{date}}',
      copyAction: 'Link kopieren',
      copyDone: 'Kopiert',
      copySuccess: 'Checkout-Link kopiert.',
      copyError: 'Checkout-Link konnte nicht kopiert werden.',
      openAction: 'Link öffnen',
      urlUnavailable: 'Checkout-URL nicht verfügbar.',
      listTitle: 'Erstellte Links',
      listDescription: 'Vorherige Links und Status für diesen Kunden.',
      listNote: 'URLs werden für vorherige Links nicht zurückgegeben. Erzeuge einen neuen Link zum Teilen.',
      refresh: 'Aktualisieren',
      loading: 'Checkout-Links werden geladen...',
      retry: 'Erneut versuchen',
      empty: 'Noch keine Checkout-Links erstellt.',
      optionsError: 'Checkout-Link-Optionen sind nicht verfügbar.',
      loadError: 'Checkout-Links konnten nicht geladen werden.',
      table: {
        status: 'Status',
        product: 'Produkt',
        planPackage: 'Plan / Paket',
        pricing: 'Preis',
        currency: 'Währung',
        created: 'Erstellt',
        expires: 'Läuft ab',
        used: 'Verwendet'
      },
      form: {
        productId: 'Produkt',
        productIdPlaceholder: 'Produkt auswählen',
        noProducts: 'Keine Produkte verfügbar',
        selectionType: 'Checkout-Typ',
        selectionTypePlaceholder: 'Plan oder Paket auswählen',
        selectionPlan: 'Abonnementplan',
        selectionPackage: 'Credit-Paket',
        planId: 'Plan',
        planIdPlaceholder: 'Plan auswählen',
        noPlans: 'Keine Pläne verfügbar',
        variantLabel: 'Variante',
        packageId: 'Paket',
        packageIdPlaceholder: 'Paket auswählen',
        noPackages: 'Keine Pakete verfügbar',
        priceId: 'Preis',
        priceIdPlaceholder: 'Preis auswählen',
        noPrices: 'Keine Preise verfügbar',
        expiresAt: 'Ablaufdatum',
        expiresAtPlaceholder: 'tt/mm/jjjj',
        expiresAtHint: 'Standardmäßig 1 Tag ab jetzt.',
        planHint: 'Für einmalige Credits bitte Credit-Pakete verwenden.',
        packageHint: 'Pakete werden für Credit-Bundles verwendet.',
        priceSummary: 'Währung {{currency}} - {{cycle}}',
        priceSummaryNoCycle: 'Währung {{currency}}'
      },
      validation: {
        productRequired: 'Produkt-ID ist erforderlich.',
        cycleRequired: 'Abrechnungszyklus-ID ist erforderlich.',
        priceRequired: 'Preis-ID ist erforderlich.',
        planRequired: 'Plan-Auswahl ist erforderlich.',
        packageRequired: 'Paket-Auswahl ist erforderlich.',
        priceInvalid: 'Ausgewählter Preis ist ungültig.',
        expiresAtInvalid: 'Ablaufdatum ist ungültig.',
        expiresAtFuture: 'Ablaufdatum muss in der Zukunft liegen.'
      },
      status: {
        active: 'Aktiv',
        expired: 'Abgelaufen',
        consumed: 'Verbraucht'
      },
      planLabel: 'Plan',
      packageLabel: 'Paket',
      cycleLabel: 'Zyklus',
      priceLabel: 'Preis'
    },
    providerList: {
      heading: 'Verwalte einzelne Kunden und ihre Team-Beziehungen',
      retry: 'Erneut versuchen',
      empty: 'Keine Kunden passen aktuell zu deinen Filtern.',
      refresh: 'Aktualisieren',
      addCustomer: 'Kunde hinzufügen',
      trial: 'Testphase',
      trialEnds: 'Endet am {{date}}',
      trialDays: 'Testphase: {{count}} Tage',
      trialRemaining_one: '{{count}} Tag verbleibend',
      trialRemaining_other: '{{count}} Tage verbleibend',
      teamsAndRoles: 'Teams & Rollen',
      joined: 'Beigetreten am {{date}}',
      created: 'Erstellt am {{date}}',
      updated: 'Zuletzt aktualisiert am {{date}}',
      stats: {
        totalCustomers: 'Gesamte Kunden',
        teamOwners: 'Team-Inhaber',
        teamMembers: 'Team-Mitglieder',
        individuals: 'Einzelkunden',
        trialing: 'In Testphase',
        uniqueTeams: 'Eindeutige Teams'
      },
      statusFallback: {
        all: 'Alle Status',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        trial: 'Testphase',
        suspended: 'Gesperrt',
        pendingVerification: 'Bestätigung ausstehend'
      },
      filters: {
        allRoles: 'Alle Rollen',
        owner: 'Team-Inhaber',
        admin: 'Team-Admins',
        member: 'Team-Mitglieder',
        individual: 'Einzelkunden',
        allTeams: 'Alle Teams',
        searchPlaceholder: 'Nach Name, E-Mail oder Unternehmen suchen…',
        teamPlaceholder: 'Alle Teams'
      },
      views: {
        active: 'Aktiv',
        deleted: 'Archiviert',
      },
      deleted: {
        empty: 'Keine archivierten Kunden gefunden.',
      },
      actions: {
        viewCustomer: 'Details anzeigen',
        editCustomer: 'Kunde bearbeiten',
        manageSubscriptions: 'Abonnements verwalten',
        checkoutLinks: 'Checkout-Links',
        suspendAccount: 'Account sperren',
        deleteCustomer: 'Kunde archivieren',
        restoreCustomer: 'Kunde wiederherstellen',
      },
      errors: {
        forbidden: 'Du bist für diese Aktion nicht berechtigt.',
        unauthorized: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
        notFound: 'Kunde für diesen Provider nicht gefunden.',
      },
      delete: {
        title: 'Kunde löschen',
        titleSoft: 'Kunde archivieren',
        titleHard: 'Kunde dauerhaft löschen',
        description: 'Wähle, wie dieser Kunde entfernt werden soll.',
        soft: 'Archivieren',
        hard: 'Dauerhaft löschen',
        hardWarning: 'Dauerhaftes Löschen ist endgültig. Gib zur Bestätigung die E-Mail des Kunden ein.',
        activeSubscriptionTitle: 'Dauerhaftes Löschen ist wegen eines aktiven Abonnements blockiert.',
        activeSubscriptionBlocked:
          'Kündige oder beende das aktive Abonnement, bevor du dauerhaft löschst.',
        subscriptionPlan: 'Plan',
        subscriptionStatus: 'Status',
        subscriptionPeriodEnd: 'Aktuelle Abrechnungsperiode endet (UTC)',
        switchToArchive: 'Zu Archivieren wechseln',
        reason: 'Grund (optional)',
        deleting: 'Lösche...',
        confirmSoft: 'Kunde archivieren',
        confirmHard: 'Dauerhaft löschen',
        success: 'Kunde erfolgreich gelöscht.',
        error: 'Kunde konnte nicht gelöscht werden.',
        confirmMismatch: 'Bitte gib zur Bestätigung der dauerhaften Löschung exakt die Kunden-E-Mail ein.',
      },
      restore: {
        title: 'Kunde wiederherstellen',
        description: '{{email}} wieder zu aktiven Kunden verschieben?',
        restoring: 'Stelle wieder her...',
        success: 'Kunde erfolgreich wiederhergestellt.',
        error: 'Kunde konnte nicht wiederhergestellt werden.',
      },
      table: {
        customer: 'Kunde',
        status: 'Status',
        trial: 'Testphase',
        teams: 'Teams & Rollen',
        created: 'Erstellt',
        actions: 'Aktionen'
      },
      metrics: {
        teamsCount: 'Teams: {{count}}'
      },
      pagination: {
        range: '{{from}}-{{to}} von {{total}}',
        perPageLabel: 'Zeilen pro Seite',
        perPageOption: '{{count}} pro Seite',
        previous: 'Zurück',
        next: 'Weiter',
        pageLabel: 'Seite {{current}} von {{total}}'
      }
    }
  } as const;

export default customers;
